import React from 'react';

function Footer()  {
 
    return <footer>&copy; mohammad alshraideh all rights reserved</footer>;
  
}

export default Footer;